<template>
    <div class="page flex flex-col md:border-l md:border-r">
        <TopBarBg
            :headerText="lbl.promotion.title.special4You"
            medium
            sideMenu
        ></TopBarBg>
        <PageContent class="flex-auto" :hasPoweredBy="hasPoweredBy">
            <div class="-mt-20 mb-8">
                <div>
                    <DashboardSlider
                        :apiConfig="dashboardConfig"
                    ></DashboardSlider>
                </div>
                <div class="bg-white p-4">
                    <CampaignCategory
                        ref="campaign-category"
                        @onChangeCategory="onChangeCategory($event)"
                    >
                    </CampaignCategory>
                    <PromotionList
                        :type="type"
                        :items="itemsPromotion"
                        :modalController="modalController"
                        @onClickItem="onClickPromotionItem($event)"
                    ></PromotionList>
                </div>
            </div>
        </PageContent>
        <Footer :hasPoweredBy="hasPoweredBy" />
    </div>

    <div class="flyout-zone">
        <ModalMaster :controller="modalController"></ModalMaster>

        <VBottomSheet
            ref="bottomSheetRegister"
            v-model="bottomSheetRegister"
            :persistent="true"
        >
            <div class="px-6 mt-4 text-center">
                <div class="relative flex items-center justify-center">
                    <div class="font-semibold text-lg text-primary uppercase">
                        {{ lbl.bottomSheet.sorry }} !
                    </div>

                    <div class="absolute right-0 top-2">
                        <img
                            src="@/assets/icon/dialog/close.svg"
                            @click="closeRegister()"
                            alt
                        />
                    </div>
                </div>
                <div class="mt-10px">
                    <div
                        class="text-base text-gray-secondary"
                        v-html="lbl.promotion.bottomSheet.register"
                    ></div>
                </div>
                <div class="mt-6 mb-8">
                    <VBtn
                        blocked
                        large
                        variant="primary"
                        @click="goToRegister()"
                        >{{ lbl.register.buttons.register }}</VBtn
                    >
                </div>
            </div>
            <Footer :hasPoweredBy="false" />
        </VBottomSheet>

        <VBottomSheet
            ref="bottomSheetAddCard"
            v-model="bottomSheetAddCard"
            :persistent="true"
        >
            <div class="px-6 mt-4 text-center">
                <div class="relative flex items-center justify-center">
                    <div class="font-semibold text-lg text-primary uppercase">
                        &nbsp;
                    </div>

                    <div class="absolute right-0 top-2">
                        <img
                            src="@/assets/icon/dialog/close.svg"
                            @click="closeAddCard()"
                            alt
                        />
                    </div>
                </div>
                <div class="mt-10px">
                    <div
                        class="text-base text-gray-secondary"
                        v-html="lbl.promotion.bottomSheet.addCard"
                    ></div>
                </div>
                <div class="mt-6 mb-8">
                    <VBtn
                        blocked
                        large
                        variant="primary"
                        @click="goToProfile()"
                        >{{ lbl.profile.addCard }}</VBtn
                    >
                </div>
            </div>
            <Footer :hasPoweredBy="false" />
        </VBottomSheet>

        <VBottomSheet
            v-model="showPopupSlip"
            :dismissable="true"
            ref="btsPopupSlip"
        >
            <div class="mt-5 mx-9 mb-9">
                <div
                    class="
                        text-center text-lg text-primary
                        leading-normal
                        uppercase
                        mx-6
                        font-
                    "
                >
                    Slip
                </div>
                <div class="text-center mt-6 mb-6 rounded-md">
                    <template v-if="popupSlipImg != null">
                        <img
                            :src="popupSlipImg"
                            class="w-auto h-auto max-w-270px mx-auto shadow-md"
                        />
                    </template>
                </div>
            </div>
            <Footer :hasPoweredBy="false"></Footer>
        </VBottomSheet>
    </div>
</template>

<script>
import TopBarBg from "@/components/Layout/TopBar/TopBarBg.vue";
import PageContent from "@/components/Layout/Content/PageContent.vue";
import Footer from "@/components/Layout/Footer/Footer.vue";
import VBtn from "@/components/Button/VBtn.vue";
import ModalMaster from "@/components/Modal/ModalMaster.vue";
import VBottomSheet from "@/components/Dialog/BottomSheet.vue";
import DashboardSlider from "@/components/Dashboard/DashboardSlider.vue";
import PromotionList from "@/module/List/component/PromotionList/PromotionList.vue";
import CampaignCategory from "../component/CampaignCategory.vue";

// mixin
import ModalMixin from "@/mixin/ModalMixin";
import LocaleMixin from "@/mixin/LocaleMixin";
import ErrorApiMixin from "@/mixin/ErrorApiMixin";
import PdpaMixin from "@/mixin/PdpaMixin";

// config
import ConfigManager from "@/config/ConfigManager";

// service
import { CampaignListConfigBuilder, CampaignListFilterConfigBuilder, CampaignConfigBuilder } from "@/core/Campaign/model/CampaignConfigModel";
// import { HistoryPointConfigBuilder } from "@/core/Point/config/PointConfigModel.js";
import { PurchaseListConfigBuilder } from "@/core/History/config/HistoryConfigModel";
import BzbsCampaign from "@/core/Campaign/service/BzbsCampaign";
import BzbsHistory from "@/core/History/service/BzbsHistory.js";
import { SerialModel } from "@/core/Redeem/model/SerialModel.js";
// helper
import CacheHelper from "@/helper/CacheHelper";
import Utility from "@/helper/Utility";
import { CampaignType } from "@/helper/StaticValue";
import AccountHelper from "@/helper/AccountHelper";

//  composable
import useCreditCardComposable from "@/composables/CreditCardComposable";

export default {
    name: "SpecialForYouPage",
    mixins: [LocaleMixin, ModalMixin, ErrorApiMixin, PdpaMixin],
    components: {
        TopBarBg,
        PageContent,
        Footer,
        VBtn,
        ModalMaster,
        VBottomSheet,
        DashboardSlider,
        PromotionList,
        CampaignCategory,
        // SplideCustomPagination
    },
    data: function () {
        return {
            hasPoweredBy: false,
            acceptCondition: false,
            bottomSheetRegister: false,
            bottomSheetAddCard: false,
            shouldRegister: false,
            currentDashboard: 0,
            itemsPromotion: [],
            dashboardConfig: ConfigManager.getDashboardSpecialForYou(),
            campaignListConfig: ConfigManager.getCampaignSpecialForYou(),
            historyListConfig: null,
            trackingScreenName: "special_for_you",
            configBuilder: new CampaignListConfigBuilder(),
            filterConfig: new CampaignListFilterConfigBuilder(),
            type: "",
            isLoading: false,
            pageYOffsetTemp: 0,
            timerId: null,
            showPopupSlip: false,
            popupSlipImg: null,
        };
    },
    beforeRouteEnter(to, from, next) {
        var cache = new CacheHelper("session");
        let idToken = cache.getCache("LineIdToken");
        if (idToken == null || idToken == undefined) {
            const targetPage = to.params.categoryId
                ? `promotion/special4you/${to.params.categoryId}`
                : "promotion/special4you";
            next({
                path: "/linelogin",
                query: {
                    target_page: targetPage,
                },
            });
        } else {
            next();
        }
    },
    setup: function () {
        const { apiGetCardList, creditCardList } =
            useCreditCardComposable(false);

        return {
            creditCardList,
            apiGetCardList,
        };
    },
    created: function () {
        this.setScrollLoadMore();
        // TODO! comment below line
        // this.configBuilder.setTop(10);
    },
    mounted: function () {
        // this.getCampaign()
        this.init();
        this.tracking.screenName(this.trackingScreenName);
    },
    beforeUnmount: function () {
        window.onscroll = null;
    },
    methods: {
        // mixin handler
        onSetupModalCompleted: function () {
            this.initialRedeemModal();
        },
        // page mthods
        init: function () {
            return new Promise((resolve) => {
                let user = AccountHelper.getCacheUser();
                if (user == null) {
                    if (!this.$route.params.categoryId) {
                        this.bottomSheetRegister = true;
                        this.shouldRegister = true;
                    }
                    resolve();
                } else {
                    // try check apply card
                    this.apiGetCardList().then((cards) => {
                        if (cards.length == 0) {
                            this.shouldRegister = true;
                            this.bottomSheetAddCard = true;
                        }
                        resolve();
                    });
                }
            });
        },
        setScrollLoadMore: function () {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                var scrollOffSet = 100;
                var pageHeight = Math.max(
                    window.pageYOffset,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                var bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;

                let offsetYNew = window.pageYOffset;
                if (this.pageYOffsetTemp < offsetYNew) {
                    // direction scroll down
                    if (bottomOfWindow) {
                        // debounce load more
                        clearTimeout(this.timerId);
                        this.timerId = setTimeout(() => {
                            this.loadMore();
                        }, 250);
                    }
                }
                this.pageYOffsetTemp = offsetYNew;
            };
        },
        loadMore: function () {
            if (this.isLoading) {
                return;
            } else {
                // set builder
                if (this.type == "history") {
                    // history loadMore is handled inside PromotionHistory component
                    return;
                } else {
                    if (this.configBuilder.campaignListConfig.isSeeMoreEnable) {
                        this.getCampaign();
                    }
                }
            }
        },
        getCampaign: function () {
            // console.log(this.configBuilder.campaignListConfig)
            this.isLoading = true;
            return new Promise((resolve) => {
                this.loadingModal.show();

                this.configBuilder.setLocale(this.localeCode);
                this.configBuilder.setConfigList(this.campaignListConfig);

                var params = this.configBuilder.create();
                BzbsCampaign.apiGetCampaign(
                    params,
                    this.filterConfig.create()
                ).subscribe({
                    next: (data) => {
                        this.configBuilder.setSkip(
                            this.configBuilder.campaignListConfig.intSkip +
                                this.configBuilder.campaignListConfig
                                    .defaultTopAmount
                        );

                        if (data && data.length < this.configBuilder.campaignListConfig.defaultTopAmount) {
                            this.configBuilder.campaignListConfig.isSeeMoreEnable = false
                        }

                        this.itemsPromotion = this.itemsPromotion.concat(data);
                        this.loadingModal.hide();
                        resolve(data);
                        // console.log(data)
                        this.isLoading = false;
                    },
                    error: (err) => {
                        this.isLoading = false;
                        this.loadingModal.hide();
                        this.errorApi(err);
                        resolve(null);
                    },
                });
            });
        },
        onClickDotNav: function (idx) {
            this.currentDashboard = idx;
            this.$refs.dashboard.goTo(idx);
        },
        closeRegister: function () {
            // this.$refs.bottomSheetRegister.hide()
            this.goToRegister();
        },
        closeAddCard: function () {
            // this.$refs.bottomSheetAddCard.hide()
            this.goToProfile();
        },
        goToRegister: function () {
            this.redirectToRegisterWithReturn();
        },
        goToProfile: function () {
            this.$router.push({
                name: "profile",
            });
        },
        getSpecial4YouTargetPage: function () {
            if (this.$route.params.categoryId) {
                return `promotion/special4you/${this.$route.params.categoryId}`;
            }
            return "promotion/special4you";
        },
        redirectToRegisterWithReturn: function () {
            const cache = new CacheHelper("session");
            cache.setCache(
                "special4you.redirect.target_page",
                this.getSpecial4YouTargetPage()
            );
            this.$router.replace({
                name: "register",
            });
        },
        /**
         * @method onClickPromotionItem
         * @param {import("@/core/Campaign/model/CampaignModel").default} campaign
         */
        onClickPromotionItem: function (campaign) {
            var tracking_label = campaign.id + "|" + campaign.name;
            this.tracking.event(
                "campaign_list",
                "click_campaign_list",
                tracking_label,
                null
            );

            if (campaign.type == CampaignType.Event) {
                if (!Utility.isEmptyStr(campaign.customFacebookMessage)) {
                    // expect case
                    window.location.href = campaign.customFacebookMessage;
                } else {
                    // do nothing
                    // this.$router.push('/promotion/detail/' + campaign.id);
                }
            } else {
                this.$router.push({
                    name: "promotion-detail",
                    params: {
                        campaignId: campaign.id,
                    },
                });
            }
        },
        onChangeCategory: function (catId) {
            if (this.$route.name !== "promotion-special4you") {
                return;
            }
            if (String(this.$route.params.categoryId || "") !== String(catId)) {
                this.$router.replace({
                    name: "promotion-special4you",
                    params: {
                        categoryId: String(catId),
                    },
                });
            }

            this.itemsPromotion = [];
            let catDetail =
                this.$refs["campaign-category"].getCateDetail(catId);
            if (catDetail == null) {
                return;
            }

            let user = AccountHelper.getCacheUser();
            const isHistoryTab =
                catDetail.detail != null &&
                catDetail.detail.toLowerCase() == "history";

            if (isHistoryTab && user == null) {
                this.redirectToRegisterWithReturn();
                return;
            }

            if (!isHistoryTab && user == null) {
                this.bottomSheetRegister = true;
                this.shouldRegister = true;
            }

            this.setTracking(catDetail.name);
            if (isHistoryTab) {
                this.type = "history";
            } else {
                this.type = "";
                this.configBuilder.setSkip(0);
                this.configBuilder.setCatId(catId);
                this.configBuilder.setSeeMore(true);
                this.getCampaign();
            }
        },
        setTracking: function (tabName) {
            let trackCategory = "tab_menu";
            let trackAction = "";
            switch (tabName.toLowerCase()) {
                case "exclusive deal":
                    trackAction = "click_exclusive_deal";
                    break;
                case "jcb reward":
                    trackAction = "click_jcb_reward";
                    break;
                case "my voucher":
                    trackAction = "click_my_voucher";
                    break;
            }
            this.tracking.event(trackCategory, trackAction, null, null);
        },

        //======(start) History section======
        getHistory: function () {
            return new Promise((resolve) => {
                this.loadingModal.show();
                BzbsHistory.apiGetPurchase(
                    this.historyListConfig,
                    null
                ).subscribe({
                    next: (data) => {
                        if (
                            data &&
                            data.length <
                                this.historyListConfig.defaultTopAmount
                        ) {
                            this.historyListConfig.setSeeMoreEnable(false);
                        }

                        if (data.length > 0) {
                            this.historyListConfig.increstSkip();
                            this.itemsPromotion =
                                this.itemsPromotion.concat(data);
                        }
                        this.loadingModal.hide();
                        resolve(data);
                        // console.log(data)
                    },
                    error: (err) => {
                        this.loadingModal.hide();
                        this.errorApi(err);
                        resolve(null);
                    },
                });
            });
        },
        onClickPurchase: async function (purchase) {
            if (purchase.type === CampaignType.Interface) {
                this.openInterfaceHistory(purchase);
                return;
            }

            this.loadingModal.show();
            var campaignDetail = await this.getCampaignDetail(purchase.id);
            if (campaignDetail.customFacebookMessage) {
                purchase.customFacebookMessage = campaignDetail.customFacebookMessage;
            }
            this.loadingModal.hide();

            this.isSerialLoading = true;
            this.modalController.confirmUsedModal
                .clearModal()
                .setCampaign(purchase)
                .show();
            this.modalController.confirmUsedModal.onClickOk(() => {
                this.useCampaign(purchase);
            })
        },
        getCampaignDetail: function (campaignId) {
            return new Promise((resolve) => {
                const configBuilder = new CampaignConfigBuilder()
                const config = configBuilder
                    .setCampaignId(campaignId)
                    .setLocale(this.localeCode)
                    .create();

                BzbsCampaign.apiGetCampaignDetail(config).subscribe({
                    next: (data) => {
                        resolve(data);
                    },
                    error: (err) => {
                        this.errorApi(err);
                        resolve(null);
                    },
                });
            });
        },
        useCampaign: function (purchase) {
            BzbsHistory.apiRedeemUse(purchase.redeemKey).subscribe(
                (result) => {
                    this.isSerialLoading = false;
                    purchase.updateAfterRedeem(result);

                    if (this.isShowSerialModal(purchase)) {
                        this.openSerial(purchase);
                    }
                },
                (err) => {
                    this.isSerialLoading = false;
                    console.log(err);
                }
            );
        },
        onClickViewSlip: function (purchase) {
            let info1 = purchase.info1 ?? null;
            if (info1 != null) {
                let json = JSON.parse(info1);
                this.popupSlipImg = json?.[0]?.image_url ?? "";
                this.$refs.btsPopupSlip.show();
            }
        },
        openSerial: function (purchase) {
            let serialModel = new SerialModel();
            serialModel.setModelFromDataModel(purchase);

            this.modalController.serialModal
                .clearModal()
                .setSerial(serialModel)
                .show();
            this.modalController.serialModal.onSerialExpire(() => {
                purchase.setPurchaseExpired();
                this.refreshList();
            });
            this.modalController.serialModal.onCloseModal(() => {
                this.refreshList();
            });
        },
        openInterfaceHistory: function (purchase) {
            var sToken = AccountHelper.getTokenShuffle();
            var locale = this.localeCode;
            var header = "false";
            var theme = ConfigManager.getAppName();
            var returnUrl = encodeURIComponent(window.location.href);

            // new generation landing interface
            if (purchase.privilegeMessageFormat == "link") {
                var url = purchase.privilegeMessage;

                url = url.replace("<campaign_id>", purchase.id);
                url = url.replace("<token>", sToken);
                url = url.replace("<serial>", purchase.serial);
                url = url.replace("<locale>", this.localeCode);

                url += "&return_url=" + returnUrl;

                window.location.replace(url);
                return;
            }

            // old default landing interface
            if (purchase.website && purchase.website.indexOf("starbucks") > 0) {
                let url =
                    purchase.website +
                    "&token=" +
                    sToken +
                    "&locale=" +
                    locale +
                    "&RedeemKey=" +
                    purchase.redeemKey +
                    "&header=" +
                    header +
                    "&theme=" +
                    theme +
                    "&return_url=" +
                    returnUrl; // ReturnUrl;
                window.location.replace(url);
            } else if (
                purchase.website &&
                purchase.website.indexOf("linesticker") > 0
            ) {
                let url =
                    purchase.website +
                    "&info2=" +
                    purchase.info2 +
                    "&info3=" +
                    purchase.info3 +
                    "&locale=" +
                    locale +
                    "&return_url=" +
                    encodeURIComponent(window.location.href) +
                    "&token=" +
                    sToken +
                    "&is_history=true";
                window.location.replace(url);
            }
        },
        isShowSerialModal: function (purchase) {
            if (purchase.serial === "XXXXXXX") {
                return false;
            }
            if (purchase.expireIn && purchase.expireIn <= 0) {
                return false;
            }

            if (purchase.type === CampaignType.Interface) {
                if (purchase.pointType === "get") return false;

                return true;
            }

            if (
                purchase.type === CampaignType.Free ||
                purchase.type === CampaignType.Deal ||
                purchase.type === CampaignType.Buy
            ) {
                if (purchase.delivered) {
                    return false;
                }
            }

            if (purchase.type === CampaignType.Draw) {
                return false;
            }

            return true;
        },
        refreshList: function () {
            // Clear the current list
            this.itemsPromotion = [];
            // Reload data based on current tab
            if (this.type === "history") {
                this.historyListConfig = new PurchaseListConfigBuilder()
                    .setConfigList(ConfigManager.getHistPurchaseUnused())
                    .setType("list")
                    .setTop(25)
                    .create();
                this.getHistory();
            } else {
                this.window.location.reload();
            }
        }
        //======(end) History section======
    },
};
</script>
